import { useConfirmationDialogContext } from "@shared";
import { useAlertContext } from "@shared";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { CourtResponse, courtsApi } from "@/api";
import { QueryKey } from "@/query/Query";
import { useTranslation } from "@/translations";

export function useCourtDelete(onDeleted?: () => void) {
  const { t } = useTranslation();
  const { showSuccess } = useAlertContext();
  const { showConfirmationDialog } = useConfirmationDialogContext();
  const queryClient = useQueryClient();

  const deleteMutation = useMutation({
    mutationFn: (id: string) => courtsApi.deleteCourt({ id }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [QueryKey.Courts] });
      void queryClient.invalidateQueries({ queryKey: [QueryKey.AvailableCourtDistricts] });
      showSuccess(t("settings.courts.successfullyDeleted"));
      onDeleted?.();
    },
  });

  const confirmAndDelete = (court: CourtResponse) => {
    showConfirmationDialog({
      dialogTitleText: t("settings.courts.deleteConfirmTitle"),
      dialogText: t("settings.courts.deleteConfirmText", { name: court.name }),
      agreeText: t("common.yes"),
      discardText: t("common.no"),
      onClose: (confirmed) => {
        if (confirmed) {
          deleteMutation.mutate(court.id);
        }
      },
    });
  };

  return { confirmAndDelete, isDeleting: deleteMutation.isPending };
}
